var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"r-profile-wishlist-container"},[_c(_vm.typeName,_vm._g(_vm._b({tag:"component"},'component',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }